import { motion } from 'framer-motion';
import styled from 'styled-components';

export const TickerWrapper = styled.div`
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        max-width: 480px;
        display: block;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        max-width: 100%;
    }
`;

export const Ticker = styled(motion.div)`
    max-width: 100%;
`;
